/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-06-16 20:41:05
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-09-27 13:41:20
 */
// import { getCongifInfo } from "@/api/api-operation-service";
// import config from "../config/config";
import i18n from "@/config/i18n";
import { Modal } from "view-design";
/**
 * 权限路由循环
 * @param list 接口权限数据
 * @param key 给数据加上 menuIndex ,用在路由切换是找到切换的菜单，让它高亮
 * @returns
 */
export const routerFor = (list, key) => {
    // 第一个 有效的权限  url
    let itemData = null; // eslint-disable-line  
    const arr = []; // 头部和左边要显示的菜单
    const routerAutoArr = []; // 有查看权限的菜单路由，把子权限菜单全部都拿出来放在同一级数据，不要 children,[{},{},{}]
    let itemIndex = 0;
    list.map((item) => {
        let isTrue = false;
        if (item.privilegeVoList) {
            item.privilegeVoList.map((vo) => {
                if (vo.privilegeCode == "100501" && vo.checked) {
                    if ((!itemData && !item.children) ||
                        (!itemData && item.children.length == 0)) {
                        itemData = item;
                    }
                    isTrue = true;
                }
            });
        }
        if (!item.privilegeVoList) {
            isTrue = true;
        }
        if (key) {
            item.menuIndex = key + "-" + itemIndex;
        }
        else {
            item.menuIndex = itemIndex + "";
        }
        if ((isTrue && !item.children) || (isTrue && item.children.length == 0)) {
            routerAutoArr.push(item);
        }
        if (item.children) {
            const childrenData = routerFor(item.children, item.menuIndex);
            item.children = childrenData.arr;
            routerAutoArr.push(...childrenData.routerAutoArr);
            if (!itemData && childrenData.itemData) {
                itemData = childrenData.itemData;
            }
        }
        if (isTrue) {
            itemIndex = itemIndex + 1;
            arr.push(item);
        }
    });
    return { arr: arr, routerAutoArr: routerAutoArr, itemData: itemData };
};
/**
 * 充值成功操作
 * @param data
 * @param call
 */
export const rechargeSuccessTips = (data, call) => {
    // const ret = await getCongifInfo({});
    let text = "";
    // if (ret.status === config.apiStatus) {
    //   const data: objAny = ret.data[0] || {};
    //   const hasOpenCashAudit = data.hasOpenCashAudit;
    //   if (hasOpenCashAudit) {
    //     text = `<p>${i18n.t("memberList.rechargeSuccessTips")}</p>`;
    //   }
    // }
    if (data.orderStatus == 3) {
        text = `<p>${i18n.t("memberList.rechargeSuccessTips")}</p>`;
    }
    Modal.success({
        title: i18n.t("memberList.rechargeSuccess") + "",
        content: text,
        onOk: () => {
            call && call();
        },
    });
};
/**
 * 费率时间是否选择了 24小时
 * @param list 已经选择的时间数组 []
 * @returns 返回重复的时间数组
 */
export const isTime24 = (list) => {
    // 1、按分钟把选择中 点 和 点半 的时候筛选出来，结束时间减半小时（不然像结束时间为 10 ， 下个开始为 10点半 这个情况对比不出来，因为10 和 10：30都存在）
    // 2、把24小时每隔半小时间的 按分钟 组成一个数组
    // 3、对比 1 数组对照 2 数组，看有没有漏掉
    const arr = [];
    for (const i in list) {
        const last = list[i][1] == "00:00" ? "24:00" : list[i][1];
        const minTime = list[i][0].split(":");
        const maxTime = last.split(":");
        let maxTime0;
        let maxTime1;
        if (maxTime[0] !== "24") {
            maxTime0 = parseInt(maxTime[0]);
            maxTime1 = parseInt(maxTime[1]);
            if (maxTime1 === 30) {
                maxTime1 = maxTime1 - 30;
            }
            else if (maxTime1 === 0) {
                maxTime0 = maxTime0 - 1;
                maxTime1 = Math.abs(maxTime1 - 30);
            }
        }
        else {
            maxTime0 = maxTime[0];
            maxTime1 = maxTime[1];
        }
        const minH = parseInt(minTime[0]);
        const minF = parseInt(minTime[1]);
        const maxH = maxTime0;
        const maxF = maxTime1;
        for (let k = minH; k <= maxH; k++) {
            if (k === minH && minF > 0) {
                arr.push(k * 60 + 30);
            }
            else if (k == maxH && maxF == 0) {
                arr.push(k * 60);
            }
            else {
                arr.push(k * 60);
                arr.push(k * 60 + 30);
            }
        }
    }
    const time = [];
    for (let i = 0; i < 24; i++) {
        time.push(i * 60);
        if (i !== 24) {
            time.push(i * 60 + 30);
        }
    }
    const t = [];
    for (const i in time) {
        let IsYes = false;
        for (const k in arr) {
            if (arr[k] === time[i]) {
                IsYes = true;
            }
        }
        if (!IsYes) {
            t.push(time[i]);
        }
    }
    const text = [];
    for (const i in t) {
        const num = t[i];
        const n = (num / 60).toFixed(0);
        const tt = n + ":" + (num % 60);
        text.push(tt);
    }
    return text;
};
/**
 * 费率时间是否重叠
 * @param data
 * @returns {  result 重叠时间}
 */
export const isHasRepeatTime = (data) => {
    const startTimeArr = [];
    const endTimeArr = [];
    data.map((item, i) => {
        const last = data[i][1] == "00:00" ? "24:00" : data[i][1];
        const minTime = data[i][0];
        const maxTime = last;
        startTimeArr.push(minTime);
        endTimeArr.push(maxTime);
    });
    const allStartTime = startTimeArr.sort();
    const allEndTime = endTimeArr.sort();
    let result = 0;
    const arr = [];
    for (let k = 1; k < allStartTime.length; k++) {
        if (allStartTime[k] < allEndTime[k - 1]) {
            if (arr.indexOf(allStartTime[k]) === -1) {
                arr.push(allStartTime[k]);
            }
            if (arr.indexOf(allEndTime[k - 1]) === -1) {
                arr.push(allEndTime[k - 1]);
            }
            result += 1;
        }
    }
    const json = {
        timeArr: arr,
        result: result > 0,
    };
    return json;
};
